import { DEFAULTS } from './defaultSettings.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { MENTION_TYPE } from './types.js';
import 'react';
import '@tiptap/pm/model';
import 'ricos-schema';
import 'ricos-schema/dist/statics/mention.defaults.json';
import 'wix-rich-content-plugin-commons';
import './mentions-44a9a625.js';
import './style-inject.es-e7b07dd7.js';
import './tiptap/suggestion.js';
import '@tiptap/react';
import '@tiptap/suggestion';
import './tiptap/MentionList.js';
import 'classnames';
import 'prop-types';
import 'ricos-context';
import 'wix-rich-content-common/libs/Tooltip';
import './MentionAvatar-c86b7bea.js';
import 'wix-rich-content-ui-components';
import './icons/AvatarIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginMentions = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: MENTION_TYPE,
    tiptapExtensions
  };
};

export { pluginMentions };
//# sourceMappingURL=editor.js.map
